import { NextRequest, NextResponse } from "next/server";

export function middleware(request: NextRequest) {
  const currentUser = request.cookies.get("user") || "";

 // console.log("*****");
  //console.log( currentUser);
  //console.log(typeof currentUser);
  console.log("***################**");
  const isLoggedIn = Boolean(typeof currentUser === "object" && "value" in currentUser ? currentUser.value : "");
  console.log("isLoggedIn"+isLoggedIn)
  const isAuthPage = request.nextUrl.pathname.startsWith("/auth/login"); // Check if accessing login page
  const isAuthPage2 = request.nextUrl.pathname.startsWith(""); // Ch
  console.log("isAuthPage"+isAuthPage)
  console.log("isAuthPage2"+isAuthPage2)
  // If user is NOT logged in, redirect to login
  if (!isLoggedIn && !isAuthPage) {
    return NextResponse.redirect(new URL("/auth/login", request.url));
  }

  // If user IS logged in and tries to visit /auth/login, redirect to /secure
  if (isLoggedIn && isAuthPage) {
    console.log("WARNING ******** ")
    return NextResponse.redirect(new URL("/secure", request.url));
  }
 

  return NextResponse.next();
}

export const config = {
  matcher: ["/secure", "/auth/login"], // Apply middleware to both routes
};
